import { ChargeTypeInstance } from '../../data/models/charge-type.model';
import type { AppDispatch } from '../../data/store';
import { upsertTripLegsWithPayableAmount } from '../../data/trip.slice';
import { financialUtils } from '../financialUtils';
import type { WebSocketSessionInfo } from './webSocketService';

interface IProviderPricingDetail {
  appointmentDate: string;
  chargeLines: ChargeTypeInstance[];
  passengerUUID: string;
  payableAmount: string;
  providerServicePricingUUIDs: string[];
  reserverationReferenceID: string;
  transportationProviderID: number;
  tripLegReferenceID: string;
  tripLegState: string;
  tripLegStatus: string;
}

enum ProviderPricingEventType {
  ProviderPricingCalculated = 'ProviderPricingCalculated',
}

/**
 * Method for handling all Task Events
 * @param sessionInfo The webSocketService sessionInfo object. Contains data copied over from the Redux store as needed
 * @param dispatch The Redux store dispatch function
 * @param detailType A string representing the type of event. Must be one of the TripLegEventType enum values
 * @param detail An object containing the event data, in this case a TripLeg
 */
function updateProviderPricing(
  sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: string,
  detail: IProviderPricingDetail,
) {
  switch (detailType) {
    case ProviderPricingEventType.ProviderPricingCalculated:
      // When a pricing calculation is completed:
      // We need to update trip legs in Tier 3 attestation
      dispatch(
        upsertTripLegsWithPayableAmount({
          tripLegReferenceID: detail.tripLegReferenceID,
          payableAmount: financialUtils.formatPrice(
            Number(detail.payableAmount),
          ),
        }),
      );
      break;
  }
}

export { ProviderPricingEventType, updateProviderPricing };
